/**
 * ACT004：活动启用状态与起止时间门禁
 * status：0 停用，1 启用（与后管 formACT004 一致）
 */

/**
 * 活动详情 startTime/endTime：兼容字符串与毫秒时间戳
 * @param {unknown} raw
 * @returns {number|null}
 */
function parseActivityDateTime(raw) {
  if (raw == null || raw === '') return null
  if (typeof raw === 'number' && Number.isFinite(raw)) return raw
  if (raw instanceof Date && !Number.isNaN(raw.getTime())) return raw.getTime()
  const text = String(raw).trim()
  if (!text) return null
  const normalized = text.replace(/-/g, '/')
  const ts = Date.parse(normalized)
  return Number.isFinite(ts) ? ts : null
}

/**
 * @param {unknown} raw
 * @returns {string}
 */
export function formatActivityDateTimeLabel(raw) {
  const ts = parseActivityDateTime(raw)
  if (ts == null) {
    const text = String(raw == null ? '' : raw).trim()
    return text
  }
  const d = new Date(ts)
  const y = d.getFullYear()
  const m = d.getMonth() + 1
  const day = d.getDate()
  const hh = String(d.getHours()).padStart(2, '0')
  const mm = String(d.getMinutes()).padStart(2, '0')
  return `${y}年${m}月${day}日 ${hh}:${mm}`
}

/** OSS images/ 下相对路径，经 getImageUrl 拼接 */
export const ACTIVITY_GATE_ICON_BY_REASON = {
  disabled: 'activity-gate/disabled.jpg',
  not_started: 'activity-gate/not-started.jpg',
  ended: 'activity-gate/ended.jpg'
}

/**
 * @param {string|undefined|null} reason
 * @returns {string}
 */
export function resolveActivityGateIconName(reason) {
  const key = String(reason || '').trim()
  return ACTIVITY_GATE_ICON_BY_REASON[key] || ACTIVITY_GATE_ICON_BY_REASON.disabled
}

/**
 * @param {{ status?: unknown, startTime?: unknown, endTime?: unknown }|null|undefined} activityData
 * @param {number} [nowMs]
 * @returns {{ blocked: boolean, reason?: string, title?: string, message?: string, detail?: string, icon?: string }}
 */
export function resolveActivityAvailabilityGate(activityData, nowMs = Date.now()) {
  if (!activityData || typeof activityData !== 'object') {
    return { blocked: false }
  }

  const status = parseInt(activityData.status, 10)
  if (!Number.isFinite(status) || status !== 1) {
    return {
      blocked: true,
      reason: 'disabled',
      title: '活动提示',
      message: '当前活动已经停止了',
      detail: '暂时无法参与，请关注后续开放通知',
      icon: ACTIVITY_GATE_ICON_BY_REASON.disabled
    }
  }

  const startTs = parseActivityDateTime(activityData.startTime)
  if (startTs != null && nowMs < startTs) {
    const when = formatActivityDateTimeLabel(activityData.startTime)
    return {
      blocked: true,
      reason: 'not_started',
      title: '活动提示',
      message: '活动还没有开始',
      detail: when ? `活动将于 ${when} 开始` : '请稍后再来参与',
      icon: ACTIVITY_GATE_ICON_BY_REASON.not_started
    }
  }

  const endTs = parseActivityDateTime(activityData.endTime)
  if (endTs != null && nowMs > endTs) {
    return {
      blocked: true,
      reason: 'ended',
      title: '活动提示',
      message: '活动已经结束了',
      detail: '欢迎下次参与',
      icon: ACTIVITY_GATE_ICON_BY_REASON.ended
    }
  }

  return { blocked: false }
}
